import Highcharts from 'highcharts';
import moment from 'moment-timezone';
import translate from '../common/localization/translate';

export default function localizeHighcharts(decimalPoint, thousandsSep) {
  const localeData = moment.localeData();
  const lang = {
    analysisButton: translate('javascript.TX_GOTO_ANALYSIS'),
    contextButtonTitle: translate('vendor.highcharts.CONTEXT_BUTTON_TITLE'),
    decimalPoint,
    downloadCSV: translate('vendor.highcharts.DOWNLOAD_CSV'),
    downloadJPEG: translate('vendor.highcharts.DOWNLOAD_JPEG'),
    downloadPDF: translate('vendor.highcharts.DOWNLOAD_PDF'),
    downloadPNG: translate('vendor.highcharts.DOWNLOAD_PNG'),
    downloadSVG: translate('vendor.highcharts.DOWNLOAD_SVG'),
    downloadXLS: translate('vendor.highcharts.DOWNLOAD_XLS'),
    evaluationButton: translate('javascript.TX_GOTO_EVALUATION'),
    helpButton: translate('common.INFORMATION'),
    months: localeData.months(),
    printChart: translate('vendor.highcharts.PRINT'),
    resetZoom: translate('vendor.highcharts.RESET_ZOOM'),
    shortMonths: localeData.monthsShort(),
    shortWeekdays: localeData.weekdaysShort(),
    thousandsSep,
    weekdays: localeData.weekdays(),
  };

  Highcharts.setOptions({ lang });
}
